module.exports = __webpack_public_path__ + "img/4.54a7676c.jpg";